"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [["albo", "albo"], ["ani", "ani"], ["czy", "czy"], ["im", "tym"], ["tak", "jak"]];
};